/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse
     */
    result?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse
     */
    errorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse
     */
    errorMessage?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
        'errorCode': !exists(json, 'errorCode') ? undefined : json['errorCode'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
        'errorCode': value.errorCode,
        'errorMessage': value.errorMessage,
    };
}

